import { css } from 'lit'

export default css`
    :host {
        display: block;
    }

    .root {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .root > div {
        height: 100%;
    }

    .main {
        flex-grow: 1;
        border: none;
        font-weight: var(--font-weight-regular);
        font-size: 16px;
    }
    .main:focus {
        outline: none;
    }
    .root--full-mode .main {
        margin-left: 8px;
    }

    .tag-input-wrapper {
        display: flex;
        border: 1px solid var(--grey5);
        border-radius: 5px;
        align-items: center;
    }
    .tag-input-wrapper:focus {
        border: 1px solid var(--purple);
    }
    .tag-input-wrapper:focus-within {
        border: 1px solid var(--purple);
    }
    .tag-input-wrapper > svg {
        margin-right: 20px;
    }
    .root--full-mode .tag-input-wrapper {
        margin: 15px;
    }

    .tag-input {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
        padding: 8px 16px;
    }

    .tag-input--limited-height {
        max-height: 100px;
        overflow-y: auto;
    }

    .magnifier-icon {
        line-height: 0;
    }

    .selected {
        display: flex;
        align-items: center;
        border: 1px solid var(--grey8);
        padding: 5px;
        font-weight: var(--font-weight-medium);
        font-size: 14px;
        color: var(--darkGrey);
        justify-content: space-between;
        background: var(--grey8);
        border-radius: 20px;
    }

    .selected > zaptic-delete-icon {
        display: flex;
    }

    .selected-tag {
        display: flex;
        align-items: center;
        flex-grow: 1;
    }

    .selected-tag-name {
        display: flex;
        align-items: center;
        text-align: center;
        margin: 0px 5px;
        font-weight: var(--font-weight-medium);
        line-height: 14px;
        color: var(--darkGrey);
    }

    .selected-single-tag {
        display: flex;
        width: 100%;
        align-items: center;
        margin: 8px 16px;
        color: var(--darkGrey);
        font-weight: var(--font-weight-medium);
        line-height: 19.12px;
    }

    .footer {
        align-items: center;
        border-top: 1px solid var(--grey5);
        display: flex;
        height: 48px;
    }

    .footer--padded {
        padding: 0 1rem;
        justify-content: flex-end;
    }

    .chevron-up {
        transform: rotate(180deg);
    }

    .delete-all-icon {
        display: flex;
        margin-right: 15px;
    }

    .display-no-data {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 250px;
    }

    .display-no-data-text {
        padding-bottom: 15px;
        color: var(--grey3);
        font-weight: var(--font-weight-medium);
        font-size: 14px;
    }
`
